const pageNameKey = "blueprintStateInfoBannerAuthorDateWrapper";

export const blueprintStateInfoBannerAuthorDateWrapperEn = {
  [pageNameKey]: {
    by: "by",
    swatchBookIconAltText: "Swatch Book Icon",
  },
};

export const blueprintStateInfoBannerAuthorDateWrapperPtBr = {
  [pageNameKey]: {
    by: "por",
    swatchBookIconAltText: "Ícone do Livro de Amostras",
  },
};

export const blueprintStateInfoBannerAuthorDateWrapperDe = {
  [pageNameKey]: {
    by: "von",
    swatchBookIconAltText: "Farbfächer-Icon",
  },
};

export const blueprintStateInfoBannerAuthorDateWrapperZhHans = {
  [pageNameKey]: {
    by: "由",
    swatchBookIconAltText: "调色板图标",
  },
};

export const blueprintStateInfoBannerAuthorDateWrapperIt = {
  [pageNameKey]: {
    by: "di",
    swatchBookIconAltText: "Icona del libro dei campioni",
  },
};

export const blueprintStateInfoBannerAuthorDateWrapperEs = {
  [pageNameKey]: {
    by: "por",
    swatchBookIconAltText: "Icono del muestrario",
  },
};

export const blueprintStateInfoBannerAuthorDateWrapperNl = {
  [pageNameKey]: {
    by: "van",
    swatchBookIconAltText: "Kleurenwaaier-pictogram",
  },
};

export const blueprintStateInfoBannerAuthorDateWrapperTr = {
  [pageNameKey]: {
    by: "ile",
    swatchBookIconAltText: "Renk Örneği Kitap Simgesi",
  },
};
